import React from 'react';
import { useTranslate } from '../../contexts/languageContext';
import { useEleccion } from '../../contexts/eleccionContext';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import DatosCamara from './DatosCamara';

const Camaras = (props) => {
  const elecOptions = useEleccion();
  const nomenclator = useNomenclator();
  const territorios = elecOptions?.tabs.some(t => t.id === 'territorios');
  const t = useTranslate();
  return (  
    <div className="main" style={{height: 'max-content'}}>
      {elecOptions?.camaras.map((camara, i) => {
        return (
          <section className="camaracircunscripcion" key={i}>
            <div className="camaracircunscripcion" >
              <div style={{ display: 'none' }} className="headerSection">{`${t('circunscripcion')} ${nomenclator.nomAmbitos[elecOptions.idEleccion].cam[camara.cam].ca}`} </div>
              <DatosCamara
                data={camara}
                tVisible={territorios}
                header={props.header}
                color={
                  nomenclator.nomAmbitos[elecOptions.idEleccion].cam[camara.cam]
                    .co
                }
              />
            </div>
          </section>

        );
      })}
    </div>
  );
};

export default Camaras;
